'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createCounters;

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/operator/map');

var countObj = {
    init: init,
    play: play,
    loop: loop,
    calcTop: calcTop,
    el: null,

    topOffset: 0.1,
    top: 0,
    countEnd: 0,
    currentCount: 0,
    frameDuration: 0,
    duration: 1000,
    previous: 0,
    lag: 0,
    timeStart: -1,
    timeElapsed: 0
};

function createCounters(selector) {
    selector = selector || '.js-counter';
    var elements = document.querySelectorAll(selector);
    elements = Array.prototype.slice.call(elements);
    if (!elements.length) {
        return;
    }

    var counters = elements.map(function (el) {
        var obj = Object.create(countObj);
        obj.init(el);
        return obj;
    });

    var updateCounterPlay = function updateCounterPlay(scroll) {
        counters.forEach(function (counter) {
            if (scroll >= counter.top) {
                counter.play();
            }
        });
    };

    _Observable.Observable.fromEvent(window, 'scroll').map(function () {
        return getCurrentTop() + window.innerHeight;
    }).subscribe(updateCounterPlay);

    updateCounterPlay(getCurrentTop() + window.innerHeight);

    return counters;
}

function init(element) {
    this.element = element;
    var countStart = +this.element.dataset.start || 0;
    this.countEnd = +this.element.dataset.end || this.countEnd;
    this.duration = +this.element.dataset.duration || this.duration;
    this.topOffset = +this.element.dataset.topOffset || this.topOffset;
    this.currentCount = countStart;
    this.frameDuration = this.duration / (this.countEnd - countStart);
    calcTop.call(this);

    this.loop = this.loop.bind(this);
}

function play() {
    requestAnimationFrame(this.loop);
}

function calcTop() {
    var _element$getBoundingC = this.element.getBoundingClientRect(),
        top = _element$getBoundingC.top,
        height = _element$getBoundingC.height;

    var offset = 0;
    if (this.topOffset < 1) {
        offset = window.innerHeight * this.topOffset;
    } else {
        offset = this.topOffset;
    }
    this.top = top + height + offset + getCurrentTop();
}

function incrementCount() {
    var done = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!done) {
        if (this.currentCount > this.countEnd) {
            return;
        }
        this.element.innerHTML = this.currentCount++;
    } else {
        this.element.innerHTML = this.countEnd;
    }
}

function loop() {
    if (this.timeStart == -1) {
        this.timeStart = window.performance.now();
        this.previous = this.timeStart;
    }

    var now = window.performance.now();
    var delta = now - this.previous;

    this.timeElapsed = now - this.timeStart;

    this.lag += delta;

    if (this.lag >= this.frameDuration) {
        var increNum = Math.floor(this.lag / this.frameDuration);
        for (var i = 0; i < increNum; i++) {
            incrementCount.call(this);
        }
        this.lag -= this.frameDuration * increNum;
    }

    this.previous = now;

    if (this.timeElapsed < this.duration && this.currentCount < this.countEnd) {
        requestAnimationFrame(this.loop);
    } else {
        incrementCount.call(this, true);
    }
}

function getCurrentTop() {
    return window.scrollY || window.pageYOffset;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/counter.js
// module id = ./resources/assets/js/src/ui/counter.js
// module chunks = 0